import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import SvgSlate from '../../../../__generated__/icon/SvgSlate';
import { useToast } from '../../../../hooks/useToast/useToast';
import { Button } from '../../../atom/Button/Button';
import { Input } from '../../../atom/Input/Input';
import { InputDecorator } from '../../../atom/InputDecorator/InputDecorator';
import { Modal } from '../../../atom/Modal/Modal';
import { isValidUrl } from '../_utils/isValidUrl';
interface YouTubeButtonProps {
  youTubeUrl: string;
  onSubmit: () => void;
  onYouTubeUrlChange: (url: string) => void;
}

/**
 * 에디터 툴바의 유튜브 추가 버튼
 */
export const YouTubeButton = t0 => {
  const $ = _c(18);
  const {
    youTubeUrl,
    onSubmit,
    onYouTubeUrlChange
  } = t0;
  const {
    toast
  } = useToast();
  const [isModalOpened, setIsModalOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <button className="flex size-24 items-center justify-center text-Gray-900" type="button" onClick={() => {
      setIsModalOpened(true);
    }}><SvgSlate className="size-20" /></button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsModalOpened(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onYouTubeUrlChange) {
    t3 = event => onYouTubeUrlChange(event.target.value);
    $[2] = onYouTubeUrlChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3 || $[5] !== youTubeUrl) {
    t4 = <article className="mb-32 flex flex-col gap-16"><InputDecorator label={"\uC720\uD29C\uBE0C \uC8FC\uC18C"}><Input placeholder="https://www.youtube.com/watch?v=ui6EbPMMkyw" value={youTubeUrl} onChange={t3} /></InputDecorator></article>;
    $[4] = t3;
    $[5] = youTubeUrl;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onSubmit || $[8] !== toast || $[9] !== youTubeUrl) {
    t5 = <Button className="flex-1" onClick={() => {
      if (!isValidUrl(youTubeUrl)) {
        toast({
          type: "fail",
          message: "URL \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4."
        });
        return;
      }
      setIsModalOpened(false);
      onSubmit();
    }}>설정</Button>;
    $[7] = onSubmit;
    $[8] = toast;
    $[9] = youTubeUrl;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button className="flex-1" theme="sub-fill" onClick={() => {
      setIsModalOpened(false);
    }}>취소</Button>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <footer className="flex w-full gap-8">{t5}{t6}</footer>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isModalOpened || $[15] !== t4 || $[16] !== t7) {
    t8 = <>{t1}<Modal opened={isModalOpened} onClose={t2}>{t4}{t7}</Modal></>;
    $[14] = isModalOpened;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};